import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Generate or retrieve anonymous session ID
function getSessionId() {
  let sid = sessionStorage.getItem('lc_sid');
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('lc_sid', sid);
  }
  return sid;
}

async function track(event, extra = {}) {
  // Don't track in local dev
  if (window.location.hostname === 'localhost') return;

  const token = localStorage.getItem('token');
  const accessCode = localStorage.getItem('lc_access_code');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (accessCode) headers['X-Access-Code'] = accessCode;

  try {
    await fetch('/api/analytics/event', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        event,
        path: window.location.pathname,
        referrer: document.referrer,
        session_id: getSessionId(),
        ...extra,
      }),
    });
  } catch { /* silently fail */ }
}

// Auto page-view tracking hook — add to App.js
export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (location.pathname !== lastPath.current) {
      lastPath.current = location.pathname;
      track('page_view', { path: location.pathname });
    }
  }, [location.pathname]);
}

// Named event tracker for key actions
export const analytics = {
  signupStarted:         () => track('signup_started'),
  signupCompleted:       () => track('signup_completed'),
  loginSuccess:          () => track('login_success'),
  reportStarted:         () => track('report_started'),
  reportCompleted:       () => track('report_completed'),
  contractorSignup:      () => track('contractor_signup'),
  contactFormSubmitted:  () => track('contact_submitted'),
};

export default track;
